import styled from '@emotion/styled';
import { rgba } from 'polished';
import {
  BLACK_4,
  WHITE,
  mq,
  BLACK,
  BLACK_05,
  CARD_BORDER_RADIUS,
  useThemeContext,
} from '@/features/theme';

export const WebsiteHeroContainer = styled.div(() => {
  const theme = useThemeContext();

  return {
    width: '312px',
    height: '100vh',
    gap: '32px',
    position: 'sticky',
    top: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '24px 40px',
    background: rgba(theme.primaryColor, 0.15),
    backdropFilter: 'blur(24px)',
    zIndex: '11',
    overflow: 'hidden',
    overflowY: 'auto',
    flexShrink: 0,

    '@supports (-webkit-touch-callout: none)': {
      height: '-webkit-fill-available',
      minHeight: 'fit-content',
    },

    [mq.md]: {
      height: 'auto',
      minHeight: 'unset',
      width: '100%',
      flexDirection: 'row',
      padding: '16px 24px',
      alignItems: 'center',
    },

    [mq.sm]: {
      flexDirection: 'column',
      padding: '16px',
      gap: '16px',
      alignItems: 'flex-start',
      position: 'static',
      background: 'none',
      backdropFilter: 'none',
    },
  };
});

export const Logo = styled.div(() => {
  return {
    fontFamily: 'Work Sans, sans-serif',
    fontSize: '16px',
    lineHeight: '120%',
    fontWeight: '600',
    color: BLACK,
    img: { maxHeight: '32px' },
  };
});

export const WebsiteHeroWrapper = styled.div(() => {
  const theme = useThemeContext();

  return {
    padding: '16px',
    backgroundColor: WHITE,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    boxShadow: `0px 12px 40px ${BLACK_05}`,
    borderRadius: '16px',

    [mq.md]: {
      background: 'none',
      boxShadow: 'none',
      borderRadius: '0',
      flexDirection: 'row',
      padding: '0',
      alignItems: 'center',
    },

    [mq.sm]: {
      width: '100%',
      flexDirection: 'row',
      padding: '16px 24px',
      background: rgba(theme.primaryColor, 0.15),
      borderRadius: CARD_BORDER_RADIUS,
      gap: '16px',
    },
  };
});

export const WebsiteHeroImageContainer = styled.div(() => {
  return {
    borderRadius: '8px',
    width: '200px',
    height: '200px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    [mq.md]: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
    },

    [mq.sm]: {
      minWidth: '64px',
      height: '64px',
    },
  };
});

export const WebsiteHeroImage = styled.img(() => {
  return {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  };
});

export const WebsiteHeroInfo = styled.div(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',

    [mq.md]: { gap: '0' },
  };
});

export const WebsiteHeroName = styled.div(() => {
  return {
    fontFamily: 'Work Sans, sans-serif',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '130%',
    wordBreak: 'break-word',

    [mq.md]: { fontSize: '14px' },
  };
});

export const WebsiteHeroTitle = styled.div(() => {
  return {
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '150%',
    wordBreak: 'break-word',
  };
});

export const PoweredBy = styled.div(() => {
  return {
    fontWeight: '400',
    fontSize: '14px',
    color: BLACK_4,

    [mq.md]: { display: 'none' },
  };
});
